// Combined and normalized reviews from provided datasets (Facebook + Google Maps)
import { optimizeAvatarUrl } from '../lib/image'

// Lightweight placeholder avatar (inline SVG data URI)
export const defaultAvatar =
  "data:image/svg+xml;utf8,\
  <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64'>\
    <rect width='100%' height='100%' rx='8' ry='8' fill='%23e5e7eb'/>\
    <circle cx='32' cy='24' r='12' fill='%23cbd5e1'/>\
    <rect x='12' y='40' width='40' height='14' rx='7' fill='%23cbd5e1'/>\
  </svg>";

// Source: dataset_facebook-reviews-scraper_2025-09-03_09-07-05-586.json
export const facebookReviews = [
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "⭐⭐⭐⭐⭐\n\nI've had a great experience with BR.LK. Their service is professional, reliable, and customer-focused from start to finish. The team is responsive, knowledgeable, and always willing to go the extra mile to ensure everything runs smoothly.\n\nWhat stood out most was their attention to detail and commitment to delivering quality results on time. Communication was clear throughout the process, making the entire experience seamless and stress-free.\n\nI would highly recommend BR.LK to anyone looking for a trustworthy and efficient service provider. Looking forward to working with them again in the future.",
    isRecommended: true,
    date: "2026-06-08T04:36:35.000Z",
    reviewUrl: "https://www.facebook.com/thasanthan.sivakumar/posts/pfbid038A2S2gRymz4o7zrFsqhijuTFmWWS7tfADmcYm2pPC4Wa9FUYQJtja8rkNSLiZ8Kol",
    name: "Sivakumar Thasanthan",
    avatarUrl: "/avatars/sivakumar-thasanthan.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "Highly recommend this service. \n\nThe support is really good from start to end. Ravindu’s knowledge and the help he gives is genuinely valuable",
    isRecommended: true,
    date: "2026-06-07T13:45:54.000Z",
    reviewUrl: "https://www.facebook.com/maleesha.abesekara.2025/posts/pfbid02WJ7sx79JpMXH9qMkPjJGdvEfcKZm4fwxZTfv6syZ8URPhUwJpVFJfQXE3CN1H7HZl",
    name: "Maleesha Abesekara",
    avatarUrl: "/avatars/maleesha-abesekara.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "Highly recommend service. Thank you BR.lk and Ravindu for helping me throughout the process in seamless manner!",
    isRecommended: true,
    date: "2026-06-07T13:38:49.000Z",
    reviewUrl: "https://www.facebook.com/udara.karunarathna/posts/pfbid034E6z7iJLGecCBcenjgWycXc8wRcUMNvd1KRGi5QhaLnTDFM14TQR2SqNtTFw8Lkvl",
    name: "Udara Karunarathna",
    avatarUrl: "/avatars/udara-karunarathna.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "I've been freelancing for years and kept putting off the \"make it official\" step. The paperwork, the runaround, the fear of doing something wrong...\n\nThen I tried br.lk purely based on Thimira Madhusanka Thenuwara's recommendation. Got my LLC registered without the usual chaos.\n\nWhat made the difference was Ravindu. He hopped on a call every time I had a question, no matter how stupid, and made a process I was dreading feel like a 10 minute task. Most platforms hide their founder behind a support email. This one doesn't...\n\nIf you're a freelancer or running a small studio in Sri Lanka, this is the move ✦",
    isRecommended: true,
    date: "2026-04-26T11:30:56.000Z",
    reviewUrl: "https://www.facebook.com/iroshandezilva.ux/posts/pfbid0eFCrBktqz8nsqLsKoU4ae3w5YnLxNapHH3byp5rHh8M3cJZ6T47K8G2xDmf7Dunpl",
    name: "Iroshan De Zilva",
    // no public photo -> initials fallback
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "I registered my US LLC for my freelancing work through BR.lk, and the entire process was smooth and well managed. Setting up the LLC has helped me organise and manage my business finances more effectively. I truly appreciate the professional support and guidance I received throughout the process.",
    isRecommended: true,
    date: "2026-03-03T16:08:18.000Z",
    reviewUrl: "https://www.facebook.com/permalink.php?story_fbid=pfbid0tktRTidtvyinYYcXmSMm7EYVUKgXDpLPWiaV2WxktMWYBRgJUs1p7o1PGW7XqEU4l&id=61584172241750",
    name: "Miyuru Lakshan",
    avatarUrl: "/avatars/miyuru-lakshan.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "I highly recommend BR.LK for their outstanding service. Ravindhu helped me set up my payment gateway and assisted in opening a U.S. business account, which has truly supported the growth of my business and expanded my opportunities.\n\nWhat I especially appreciate is that even after completing the main work and receiving payment, he never hesitates to help whenever I need further clarification or support. That level of commitment and professionalism is truly rare.\n\nThank you, Ravindhu, for your reliable and continued support. I genuinely appreciate your service!",
    isRecommended: true,
    date: "2026-03-03T11:37:37.000Z",
    reviewUrl: "https://www.facebook.com/gayan.sampath.1293/posts/pfbid0w8iAZV7UXz4uDw1C2yPW4892NVw8VfwiohUAeumHeuDdjGVP3FhuZY864syQg7xal",
    name: "Gayan Jayasooriya",
    avatarUrl: "/avatars/gayan-jayasooriya.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "As an independent singer expanding my music career internationally, I chose BR.LK to register my business in the UK — and I couldn’t be more satisfied. The team was friendly, professional, and walked me through every step with clear explanations, making the whole process simple and stress-free. Within a very short time, I had my UK company set up — ready to connect with global platforms and payment services. What I appreciate most is how BR.LK gives creative professionals like me the legal structure and flexibility needed to manage music business seamlessly, from royalties to merch and collaborations abroad. I highly recommend BR.LK to fellow creators and entrepreneurs looking to go global with confidence.",
    isRecommended: true,
    date: "2025-12-17T07:00:55.000Z",
    reviewUrl: "https://www.facebook.com/piyath.rajapakse.1/posts/pfbid037ysMRqEwSPfKymrHSm9G8FWYVYqktVvqtz4GSPfgC38DWryh6VUceyjjFXR6R5gul",
    name: "Piyath Rajapakse",
    avatarUrl: "/avatars/piyath-rajapakse.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "⭐️⭐️⭐️⭐️⭐️ Absolutely Seamless Experience Forming My USA LLC with BR.LK\n\nI formed my USA LLC through BR.LK, and the entire experience has been absolutely seamless from start to finish. Their team is exceptionally professional quick to respond, transparent in communication, and genuinely focused on helping clients rather than just closing a sale.\n\nFrom handling the registration to guiding me through Stripe setup, bank account opening, and other post-incorporation steps, they provided continuous, hands-on support at every stage. What really stood out was their honesty and clarity they took time to explain all available options and helped me make the best decisions for my business without any hidden agendas or money-driven push.\n\nIt’s rare to find such trustworthy and knowledgeable professionals in this space. If you’re looking to set up a US company from Sri Lanka (or anywhere else), I can confidently say BR.LK is one of the best in the business. Highly recommended!",
    isRecommended: true,
    date: "2025-11-05T02:17:33.000Z",
    reviewUrl: "https://www.facebook.com/isuru.alagiyawanna.2025/posts/pfbid0po7KUYKBUpKEMTBJPzv6jprqp2FC6JaKv91D1pbww9wzW663GNPEo5TBtHrkWKSgl",
    name: "Isuru Alagiyawanna",
    avatarUrl: "/avatars/isuru-alagiyawanna.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "I formed my USA LLC through BR.lk, and the experience has been seamless from start to finish. Their response time to queries is impressive, and they provide continuous support throughout the process like setting up Stripe, opening a bank account etc. The team is genuinely trustworthy and transparent, without any money-driven attitude. They clearly explain all available options and guide you in the right direction. Truly one of the best in the business.",
    isRecommended: true,
    date: "2025-11-04T09:48:47.000Z",
    reviewUrl: "https://www.facebook.com/mahen429/posts/pfbid0cR426mHucW8FN9f5XqArXo3oidXchgvTAyZQsU2YaA6xP4XLFR7zx8mUdYJyUSmRl",
    name: "Mahendra Bandara",
    avatarUrl: "/avatars/mahendra-bandara.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "The Service was very friendly & recommended 👌",
    isRecommended: true,
    date: "2025-10-31T17:21:38.000Z",
    reviewUrl: "https://www.facebook.com/fasithnirshad/posts/pfbid02pS2jgy7R36N6vu7TUwDtazH681QZypJbYsS4fWHAsu3PYLsarXbg8PaiaZKwoPE8l",
    name: "Fasith Nirshad",
    avatarUrl: "/avatars/fasith-nirshad.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "Highly recommend as they handle everything in a friendly and a very responsible way. Thank you BR.lk!",
    isRecommended: true,
    date: "2025-10-31T13:04:09.000Z",
    reviewUrl: "https://www.facebook.com/kasun.kasun.9803150/posts/pfbid0V7yQYs66x36dUyErmaCT6NSqWpmoJzzAnTQybz2X4xCLqc5F2EHE1CEQeBRb9riGl",
    name: "Kasun Imesha",
    avatarUrl: "/avatars/kasun-imesha.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "The service was very friendly, professional, and clean. Everything went smoothly, and the details were taken care of very well. Very highly recommended!👌",
    isRecommended: true,
    date: "2025-10-25T13:08:58.000Z",
    reviewUrl: "https://www.facebook.com/iam.skrathnayake/posts/pfbid0DjHk52FCcmCvDecLWA7JBXZUm4dtn2ftDZFE11xwMXTA3uYfC8tZ6C43ZP196MHBl",
    name: "Sk Rathnayake",
    avatarUrl: "/avatars/sk-rathnayake.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "If you’re offering services to offshore clients and want to get your payment setups and business side sorted properly, this is the go-to place.\n\nI got the service of Br LK to set up my LLC, Wise Business, and Mercury accounts, and the experience was great! I reached out around the end of Sept 2025, and within about a week, everything was done smoothly.",
    isRecommended: true,
    date: "2025-10-22T04:04:02.000Z",
    reviewUrl: "https://www.facebook.com/samarasinghe.isuru/posts/pfbid02xHYeoXkV72KkCqKbRor5zCLRS6kY7RrAZi1nKzk2fXQ7k2GTxEbdoz5vqabeVivjl",
    name: "Isuru Samarasinghe",
    avatarUrl: "/avatars/isuru-samarasinghe.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "BR.LK provided outstanding support for our company’s registration and legal requirements. They handled everything professionally from start to finish — including documentation, legal advice, and all the necessary formalities. The team is knowledgeable, responsive, and truly cares about helping businesses succeed globally. We’re very satisfied with their service and highly recommend BR.LK to anyone looking for reliable business registration and consultancy support.",
    isRecommended: true,
    date: "2025-10-21T09:56:42.000Z",
    reviewUrl: "https://www.facebook.com/gimhan.gamage.96/posts/pfbid02y7bfoUCDkHH3fub54KF5LQcPiVTZDJKT6M2AHi7hwjDjeLfZkh4S3sVYheq4tKRol",
    name: "Gimhan Gamage",
    avatarUrl: "/avatars/gimhan-gamage.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "I had an excellent experience registering my USA LLC through BR.LK! Their team was incredibly helpful and professional throughout the entire process. As someone new to US business registration, I appreciated how they simplified everything and kept me informed at every step.\nThe registration was completed smoothly and efficiently, with no headaches or surprises. Their customer service was responsive and knowledgeable, answering all my questions promptly.\nHighly recommend BR.LK for anyone looking to register a US company. They deliver exactly what they promise with great service and support!",
    isRecommended: true,
    date: "2025-09-21T16:08:26.000Z",
    reviewUrl: "https://www.facebook.com/kalpa.lkm/posts/pfbid0327a2cKVCe7f4LstN5D2FfKTf7jh7LHD3jGuDPN9DWrkGZm24Qxufbfh2V6cjj4CUl",
    name: "Kalpa Madushan Perera",
    avatarUrl: "/avatars/kalpa-madushan-perera.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "They delivered my work perfectly. The BR team was professional, communicated clearly, and kept me informed throughout. Highly recommend! ⭐️⭐️⭐️⭐️⭐️",
    isRecommended: true,
    date: "2025-09-18T06:29:33.000Z",
    reviewUrl: "https://www.facebook.com/dulaj.dilshan.5876/posts/pfbid022iQhCC9UDj2CJosqq5YcW3YvTUvHzJqonuWWkPg5VSnxxRmXXVheL2EMSSkHvaoxl",
    name: "Dulaj Dilshan",
    avatarUrl: "/avatars/dulaj-dilshan.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "I contacted BR.LK and they gave me a very friendly service from the beginning. Everything was done so smoothly and very quickly. They managed to complete all my requirements with a professional touch. Highly recommended for anyone looking for reliable and hassle-free service!",
    isRecommended: true,
    date: "2025-09-06T04:30:48.000Z",
    reviewUrl: "https://www.facebook.com/dulanjaya.tennekoon/posts/pfbid02mMmztRYik6pNSFpCqdobBcQNEptyo5ZzDeGZqbdQVoYNtNG4QN47AuEBGA7s6oXl",
    name: "Dulanjaya Tennekoon",
    avatarUrl: "/avatars/dulanjaya-tennekoon.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "Outstanding service! Fast, efficient, and hassle-free. The team was professional and kept me updated every step of the way. Highly recommended! ⭐️⭐️⭐️⭐️⭐️",
    isRecommended: true,
    date: "2025-08-25T13:42:37.000Z",
    reviewUrl: "https://www.facebook.com/shashindaesh/posts/pfbid02yjJyQyddANgdbgJ1VqzaZRp9WLN7dM2WHpMCAG9uBCSgn4h3U15nWtLM4kxahZ9xl",
    name: "Shashinda Eshan",
    avatarUrl: "/avatars/shashinda-eshan.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "⭐️⭐️⭐️⭐️⭐️\n“Excellent service! Always friendly, professional, and quick to respond. Highly recommend to anyone looking for quality and reliability. Keep up the great work!”",
    isRecommended: true,
    date: "2025-08-10T11:09:28.000Z",
    reviewUrl: "https://www.facebook.com/jagath0wijerathna/posts/pfbid02NxXXj5JV8CzGhPyKwgZMcyEYXiQcdQ4ZUe31AH7HWVAokAX1xJsf2UcHoHx1GHRyl",
    name: "Jagath Wijerathna",
    avatarUrl: "/avatars/jagath-wijerathna.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "I’ve had a wonderful experience with BR.lk. They supported me in registering two companies, setting up a UK company, and even helped with Wise and Stripe. Their customer service is excellent. I highly recommend them to Sri Lankans looking to register their business in the UK or USA!",
    isRecommended: true,
    date: "2025-07-19T16:54:06.000Z",
    reviewUrl: "https://www.facebook.com/RuchiraSachinthana010/posts/pfbid02QnF2HFtKnZiZTx2gw5BQmpZoFy4yEP9pYZottFRuoMttHtUDVYTLXmYSnnQfMRtBl",
    name: "Ruchira Sachinthana",
    avatarUrl: "/avatars/ruchira-sachinthana.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "Had a great experience with BR.lk\nWe registered our business within 10 min and they helped us setup wise, stripe and finalize everything within hours.. exceptions support from the team.. highly recommend for anyone looking to register their bussiness",
    isRecommended: true,
    date: "2025-07-19T05:56:39.000Z",
    reviewUrl: "https://www.facebook.com/thimira.nirmal.336/posts/pfbid0qgf2ixuhqHpgp1LKZqR5VY72fJbQjeWwCNmRxXnPsKzv79u7gMrKzSfqxz89WaYul",
    name: "Thimira Nirmal",
    avatarUrl: "/avatars/thimira-nirmal.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "I had a fantastic experience with BR.LK! Their customer service was exceptional.  Genuinely helpful at every step. As a non-resident entrepreneur, I needed reliable support to register my business, and BR.LK made the entire process smooth and stress-free.\n\nThanks to them, I successfully registered my company Ketale Naturals (Pvt) Ltd, and I felt fully supported throughout — from paperwork to compliance guidance. They handled everything with professionalism and attention to detail.\n\nHighly recommended for anyone looking to register a US or UK company with confidence and clarity. BR.LK truly delivers on what they promise.\n\n— Ketale Naturals",
    isRecommended: true,
    date: "2025-07-13T04:23:44.000Z",
    reviewUrl: "https://www.facebook.com/musthaqthasleemlk/posts/pfbid0VMWpam34E3iC7Eu2Kuo9K6FuGnHdukiZdbVDz5ZN4byssjkaq6RqwcfNwPJGkPQJl",
    name: "Musthaq Thasleem",
    avatarUrl: "/avatars/musthaq-thasleem.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "⭐️⭐️⭐️⭐️⭐️ Excellent Service from BR.LK!⭐️⭐️⭐️⭐️⭐️\n\nI recently registered Aventure IT Solutions (Pvt) Ltd in the UK through BR.LK, and I am extremely satisfied with their service. The team was quick, efficient, and maintained excellent communication throughout the process. They delivered everything as promised, with great attention to detail and professionalism. Highly recommend BR.LK for anyone looking for reliable company registration or business services!",
    isRecommended: true,
    date: "2025-06-30T10:55:45.000Z",
    reviewUrl: "https://www.facebook.com/cilabs.chamika/posts/pfbid0ckVXg5GthcXZ3pTnVHaQSsWEEK6oj7wn1npNd6gYWpjGjQuocg6Mf2qBKnwJfu28l",
    name: "Lahiru Chamika",
    avatarUrl: "/avatars/lahiru-chamika.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "Trust my words. BR.LK exceeds your expectations. Highly recommended service!",
    isRecommended: true,
    date: "2025-06-10T12:46:38.000Z",
    reviewUrl: "https://www.facebook.com/Sandun.dinitha/posts/pfbid09JD4wwbjEc8R81jgyKZdhSCMPFtREEEU969XjmF18UDi8H9CSf8opQRq32bBrjZhl",
    name: "Dinitha Sandun Munasinghe",
    avatarUrl: "/avatars/dinitha-sandun-munasinghe.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "I registered companies in the US and UK with BR.LK, and the process was easy and fast. The team was helpful, professional, and knew exactly what I needed. I highly recommend them for anyone growing a business internationally.",
    isRecommended: true,
    date: "2025-06-09T07:36:29.000Z",
    reviewUrl: "https://www.facebook.com/Zamry1994/posts/pfbid02Q3725CmM5ZJoXuhZjMdv66g7YFXW7AKs3zyBbxhSdjNfzmDhdJPa8WdE3omGoW7jl",
    name: "Mohamed Zamry",
    avatarUrl: "/avatars/mohamed-zamry.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "I've registered entities in both the US and UK through BR.LK, and the process was smooth, quick, and stress-free. Their team is professional, efficient, and truly understands what global entrepreneurs need. Highly recommended for anyone looking to expand internationally!",
    isRecommended: true,
    date: "2025-06-09T05:17:49.000Z",
    reviewUrl: "https://www.facebook.com/stharana/posts/pfbid0eKntGGbNymg3PBkFjLFNobs2BEje21YUvdW6dXyAYdhjwBurdL3VwzqNuQhbMNVkl",
    name: "Sathyanga Tharana Agalakumbura",
    avatarUrl: "/avatars/sathyanga-tharana-agalakumbura.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "BR.LK is a game changer!\n\nI've used their services multiple times to register companies in the USA and UK, and they nailed it every single time. Fast, reliable, and super easy to work with. If you're serious about going global, BR.LK is the secret weapon you need! 💼🌍🚀",
    isRecommended: true,
    date: "2025-06-09T04:03:38.000Z",
    reviewUrl: "https://www.facebook.com/rukshanvicky96/posts/pfbid02gP3nFbWDAf5D7i7UQfB88RTPmSdWjR6bcgSVgypfhZRELpZQe5xg3AP5wNSH94uQl",
    name: "Rukshan Wickramarathna",
    avatarUrl: "/avatars/rukshan-wickramarathna.webp",
  },
  {
    facebookUrl: "https://www.facebook.com/getbrlk",
    text: "BR.LK made my business registration process in the USA incredibly smooth and hassle-free. Their professional service and expert guidance made the entire experience seamless. Highly recommend them for anyone looking to register a business with ease! ❤👍",
    isRecommended: true,
    date: "2025-02-14T11:24:26.000Z",
    reviewUrl: "https://www.facebook.com/MeshMax11/posts/pfbid02zvL9upz6492wfLLc92KXaVb75gX3xBpNx7j4t1dsvUaV4yvJsrzGoyigmdWXoRxml",
    name: "Mesh Max",
    avatarUrl: "/avatars/mesh-max.webp",
  },
];

// Source: dataset_Google-Maps-Reviews-Scraper_2025-09-03_09-08-54-345.json
export const googleReviews = [
  {
    title: "BR.LK - US/UK Company Registration & Payment Integration Expert",
    url: "https://www.google.com/maps/search/?api=1&query=BR.LK%20-%20US%2FUK%20Company%20Registration%20%26%20Payment%20Integration%20Expert&query_place_id=ChIJKz3-MfQgJm4Rjh2dtqTPtmE",
    stars: 5,
    name: "Kasun Imesha Wickramasinghe",
    date: "2025-11-01T05:54:08.114Z",
    reviewUrl: "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2tkc1ZVVmhMVjk1UVdSWWMzUlZZVkJuVUhwQ1VXYxAB!2m1!1s0x0:0x61b6cfa4b69d1d8e!3m1!1s2@1:CAIQACodChtycF9oOkdsVUVhLV95QWRYc3RVYVBnUHpCUWc%7C%7C?hl=en",
    text: "A good place that you can trust for a quality, professional and friendly service.",
    avatarUrl: "/avatars/kasun-imesha-wickramasinghe.webp",
  },
  {
    title: "BR.LK - US/UK Company Registration & Payment Integration Expert",
    url: "https://www.google.com/maps/search/?api=1&query=BR.LK%20-%20US%2FUK%20Company%20Registration%20%26%20Payment%20Integration%20Expert&query_place_id=ChIJKz3-MfQgJm4Rjh2dtqTPtmE",
    stars: 5,
    name: "gayan jayasooriya",
    date: "2025-10-23T12:58:23.889Z",
    reviewUrl: "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2xsYWVtaHNOSFZzVUVsNVNrOWZWMWxWT1ZGeFZXYxAB!2m1!1s0x0:0x61b6cfa4b69d1d8e!3m1!1s2@1:CAIQACodChtycF9oOllaemhsNHVsUEl5Sk9fV1lVOVFxVWc%7C%7C?hl=en",
    text: "Highly recommend, very supportive team and they deliver their work on time. Thank you so much",
    avatarUrl: "/avatars/gayan-jayasooriya-2.webp",
  },
  {
    title: "BR.LK - US/UK Company Registration & Payment Integration Expert",
    url: "https://www.google.com/maps/search/?api=1&query=BR.LK%20-%20US%2FUK%20Company%20Registration%20%26%20Payment%20Integration%20Expert&query_place_id=ChIJKz3-MfQgJm4Rjh2dtqTPtmE",
    stars: 5,
    name: "mahendra bandara",
    date: "2025-10-22T09:43:24.718Z",
    reviewUrl: "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2s1RFVqUTViRkZGYkhKalVXaFZRM05vVUcxM1RWRRAB!2m1!1s0x0:0x61b6cfa4b69d1d8e!3m1!1s2@1:CAIQACodChtycF9oOk5DUjQ5bFFFbHJjUWhVQ3NoUG13TVE%7C%7C?hl=en",
    text: "Got my US LLC registered with BR.lk. Process is seamless and assisted me on every step along the way to setup other relevant platforms/services. Really appreciate the service.",
    avatarUrl: "/avatars/mahendra-bandara-2.webp",
  },
  {
    title: "BR.LK - US/UK Company Registration & Payment Integration Expert",
    url: "https://www.google.com/maps/search/?api=1&query=BR.LK%20-%20US%2FUK%20Company%20Registration%20%26%20Payment%20Integration%20Expert&query_place_id=ChIJKz3-MfQgJm4Rjh2dtqTPtmE",
    stars: 5,
    name: "Prabodha Lakshan",
    date: "2025-09-18T09:23:01.535Z",
    reviewUrl: "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2tobFNEZFhkM1paVURrNVJGbEdaVWhTWlhaWmRYYxAB!2m1!1s0x0:0x61b6cfa4b69d1d8e!3m1!1s2@1:CAIQACodChtycF9oOkhlSDdXd3ZZUDk5RFlGZUhSZXZZdXc%7C%7C?hl=en",
    text: "Had an amazing GOOD experience with BR.LK!\n\nThey helped me register my businesses in both the UK and USA without any stress. The team guided me step by step, explained everything clearly, and handled the whole process smoothly. They were quick to respond and always ready to answer my questions.\n\nIf you’re in Sri Lanka and want to set up a business abroad, I recommend BR.LK. They make the process simple and reliable.",
    avatarUrl: "/avatars/prabodha-lakshan.webp",
  },
  {
    title: "BR.LK - US/UK Company Registration & Payment Integration Expert",
    url: "https://www.google.com/maps/search/?api=1&query=BR.LK%20-%20US%2FUK%20Company%20Registration%20%26%20Payment%20Integration%20Expert&query_place_id=ChIJKz3-MfQgJm4Rjh2dtqTPtmE",
    stars: 5,
    name: "Ruchira Sachinthana",
    date: "2025-07-19T16:46:05.367Z",
    reviewUrl: "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2xONU9HRlpRWGxZWkUxWFpVRTVSWEYxVHpkVE1uYxAB!2m1!1s0x0:0x61b6cfa4b69d1d8e!3m1!1s2@1:CAIQACodChtycF9oOlN5OGFZQXlYZE1XZUE5RXF1TzdTMnc%7C%7C?hl=en",
    text: "I’ve had a wonderful experience with BR.lk. I’ve registered two companies through them, and they guided me clearly and professionally through each step of the process. Setting up my UK company registration was smooth, and with their help, I was also able to set up a Wise account and Stripe without any difficulty.\n\nTheir customer experience is excellent, the team is friendly, responsive, and always ready to assist. I’m very happy with their service and highly recommend BR.lk to Sri Lankans who are planning to register their companies in the UK or USA.",
    avatarUrl: "/avatars/ruchira-sachinthana-2.webp",
  },
  {
    title: "BR.LK - US/UK Company Registration & Payment Integration Expert",
    url: "https://www.google.com/maps/search/?api=1&query=BR.LK%20-%20US%2FUK%20Company%20Registration%20%26%20Payment%20Integration%20Expert&query_place_id=ChIJKz3-MfQgJm4Rjh2dtqTPtmE",
    stars: 5,
    name: "Tim Nirmal",
    date: "2025-07-19T05:55:01.816Z",
    reviewUrl: "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT201NVozaFBjalUxV0cxM1pGTkxkbTlsZVVoRVEwRRAB!2m1!1s0x0:0x61b6cfa4b69d1d8e!3m1!1s2@1:CAIQACodChtycF9oOm55Z3hPcjU1WG13ZFNLdm9leUhEQ0E%7C%7C?hl=en",
    text: "Had a great experience with BR.lk\nWe registered our business within 10 min and they helped us setup wise, stripe and finalize everything within hours.. exceptions support from the team.. highly recommend for anyone looking to register their bussiness",
    avatarUrl: "/avatars/tim-nirmal.webp",
  },
  {
    title: "BR.LK - US/UK Company Registration & Payment Integration Expert",
    url: "https://www.google.com/maps/search/?api=1&query=BR.LK%20-%20US%2FUK%20Company%20Registration%20%26%20Payment%20Integration%20Expert&query_place_id=ChIJKz3-MfQgJm4Rjh2dtqTPtmE",
    stars: 5,
    name: "Malinda Alahakoon",
    date: "2025-07-14T13:42:02.781Z",
    reviewUrl: "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25KblFrWmFVMk5IYzAxVFltYzFTM051UnpJelVXYxAB!2m1!1s0x0:0x61b6cfa4b69d1d8e!3m1!1s2@1:CAIQACodChtycF9oOnJnQkZaU2NHc01TYmc1S3NuRzIzUWc%7C%7C?hl=en",
    text: "Absolutely fantastic experience with BR.LK!\n\nThey made setting up my US LLC from Sri Lanka feel like a breeze. From day one, their team was super responsive and walked me through every single step - company registration, getting a US address and phone number, bank account setup, even helping with Stripe.\n\nWhat really stood out was their customer service. They answered all my questions (and trust me, I had many!) patiently and clearly. No confusing jargon, just straight-up helpful guidance. The whole process that seemed intimidating at first became totally manageable with their support.\n\nIf you're in Sri Lanka looking to register a US company, BR.LK is the way to go. They know their stuff inside out and genuinely care about getting you set up properly. Highly recommend!",
    avatarUrl: "/avatars/malinda-alahakoon.webp",
  },
  {
    title: "BR.LK - US/UK Company Registration & Payment Integration Expert",
    url: "https://www.google.com/maps/search/?api=1&query=BR.LK%20-%20US%2FUK%20Company%20Registration%20%26%20Payment%20Integration%20Expert&query_place_id=ChIJKz3-MfQgJm4Rjh2dtqTPtmE",
    stars: 5,
    name: "Mohamed Musthaq",
    date: "2025-07-13T04:25:27.274Z",
    reviewUrl: "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT21sdVkwMUhiVmxCTURoRFVIZFJhVzFIT0U0NFgxRRAB!2m1!1s0x0:0x61b6cfa4b69d1d8e!3m1!1s2@1:CAIQACodChtycF9oOmluY01HbVlBMDhDUHdRaW1HOE44X1E%7C%7C?hl=en",
    text: "I had a fantastic experience with BR.LK! Their customer service was exceptional clear, and genuinely helpful at every step. As a non-resident entrepreneur, I needed reliable support to register my business, and BR.LK made the entire process smooth and stress-free.\n\nThanks to them, I successfully registered my company Ketale Naturals (Pvt) Ltd, and I felt fully supported throughout — from paperwork to compliance guidance. They handled everything with professionalism and attention to detail.\n\nHighly recommended for anyone looking to register a US or UK company with confidence and clarity. BR.LK truly delivers on what they promise.\n\n— Ketale Naturals",
    avatarUrl: "/avatars/mohamed-musthaq.webp",
  },
  {
    title: "BR.LK - US/UK Company Registration & Payment Integration Expert",
    url: "https://www.google.com/maps/search/?api=1&query=BR.LK%20-%20US%2FUK%20Company%20Registration%20%26%20Payment%20Integration%20Expert&query_place_id=ChIJKz3-MfQgJm4Rjh2dtqTPtmE",
    stars: 5,
    name: "Yasiru Udana",
    date: "2025-02-10T07:48:53.448Z",
    reviewUrl: "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VJQ0FnTURBMmNtVUhREAE!2m1!1s0x0:0x61b6cfa4b69d1d8e!3m1!1s2@1:CIHM0ogKEICAgMDA2cmUHQ%7C%7C?hl=en",
    text: "I had an excellent experience working with BR.LK to register my business as an LLC in the USA. Their team made the entire process seamless, handling everything from company formation to setting up my bank accounts, Stripe, and other essential services.\n\nTheir expertise and efficiency saved me time and ensured that everything was done correctly from the start. The support was top-notch, and they were always available to answer any questions along the way. I highly recommend BR.LK.",
    avatarUrl: "/avatars/yasiru-udana.webp",
  },
  {
    title: "BR.LK - US/UK Company Registration & Payment Integration Expert",
    url: "https://www.google.com/maps/search/?api=1&query=BR.LK%20-%20US%2FUK%20Company%20Registration%20%26%20Payment%20Integration%20Expert&query_place_id=ChIJKz3-MfQgJm4Rjh2dtqTPtmE",
    stars: 5,
    name: "Aruna Mapalagamage",
    date: "2025-01-21T09:50:54.380Z",
    reviewUrl: "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VJQ0FnSURfbUstMzZBRRAB!2m1!1s0x0:0x61b6cfa4b69d1d8e!3m1!1s2@1:CIHM0ogKEICAgID_mK-36AE%7C%7C?hl=en",
    text: "Provide exceptional service and great communications as. Highly recommended service.",
    avatarUrl: "/avatars/aruna-mapalagamage.webp",
  },
];

export const trustPilotReviews =[
    {
        title: "BR.LK - US/UK Company Registration & Payment Integration Expert",
        url: "https://www.trustpilot.com/review/br.lk",
        stars: 5,
        name: "Yasiru Udana",
        reviewUrl: "https://www.trustpilot.com/reviews/67a9afea46608f5b7400572a",
        text: "I highly recommend BR.LK! I had an excellent experience working with BR.LK to register my business as an LLC in the USA. Their team made the entire process seamless, handling everything from company formation to setting up my bank accounts, Stripe, and other essential services. Their expertise and efficiency saved me time and ensured that everything was done correctly from the start. The support was top-notch, and they were always available to answer any questions along the way. I highly recommend BR.LK!",
        avatarUrl:"https://user-images.trustpilot.com/666ddc9d397733f95e20d6b5/73x73.png"
    }
];

// Helper to avoid hotlink/CORS blocks on certain avatar hosts (e.g., Trustpilot)
const safeAvatar = (url) => {
  if (!url) return undefined;
  try {
    const u = String(url);
    if (u.includes('user-images.trustpilot.com')) {
      // Proxy through an image CDN that allows cross-origin fetches
      return `https://images.weserv.nl/?url=${encodeURIComponent(u.replace(/^https?:\/\//, ''))}&w=90&h=90&fit=cover`;
    }
    return u;
  } catch {
    return undefined;
  }
};

// Normalize to TestimonialCard props shape
export const normalizedReviews = [
  ...facebookReviews.map((r, i) => ({
    id: `fb-${i}`,
    name: r.name ||"Facebook Reviewer",
    title: "Facebook",
    avatarUrl: optimizeAvatarUrl(r.avatarUrl, 48) || defaultAvatar,
    rating: r.isRecommended ? 5 : 4,
    testimonial: r.text,
    source: "facebook",
    date: r.date,
  originalUrl: (r.reviewUrl || "").trim() || undefined,
  })),
  ...googleReviews.map((r, i) => ({
    id: `gm-${i}`,
    name: r.name || "Google Reviewer",
    title: "Google Maps",
    avatarUrl:  optimizeAvatarUrl(r.avatarUrl, 48) || defaultAvatar,
    rating: r.stars || 5,
    testimonial: r.text,
    source: "google",
  originalUrl: r.reviewUrl,
  })),
  ...trustPilotReviews.map((r, i) => ({
    id: `tp-${i}`,
    name: r.name || "TrustPilot Reviewer",
    title: "TrustPilot",
  avatarUrl:  safeAvatar(r.avatarUrl) || defaultAvatar,
    rating: r.stars || 5,
    testimonial: r.text,
    source: "trustpilot",
    date: r.date,
    originalUrl: (r.reviewUrl || "").trim() || undefined,
  })),
];
